import { MessageDescriptor, useIntl } from 'react-intl';

const useFormatMessage = function useFormatMessage(
  descriptor: MessageDescriptor
): string {
  const intl = useIntl();
  return intl.formatMessage(descriptor);
};

export default useFormatMessage;
